export const HIGHLIGHT_SEPARATOR = "|~|";

export function parseHighlightParam(raw: string): { prefix: string; suffix: string } | { exact: string } {
    if (raw.includes(HIGHLIGHT_SEPARATOR)) {
        const sepIdx = raw.indexOf(HIGHLIGHT_SEPARATOR);
        const prefix = raw.substring(0, sepIdx);
        const suffix = raw.substring(sepIdx + HIGHLIGHT_SEPARATOR.length);
        return { prefix, suffix };
    }
    return { exact: raw };
}

export function parseContextParam(raw: string): { before: string; after: string } {
    if (raw.includes(HIGHLIGHT_SEPARATOR)) {
        const sepIdx = raw.indexOf(HIGHLIGHT_SEPARATOR);
        return {
            before: raw.substring(0, sepIdx),
            after: raw.substring(sepIdx + HIGHLIGHT_SEPARATOR.length)
        };
    }
    return { before: raw, after: "" };
}

export function buildHighlightParam(text: string, maxLength = 80): string {
    const trimmed = text.trim().replace(/\s+/g, " ");
    if (trimmed.length <= maxLength) {
        return encodeURIComponent(trimmed);
    }
    const prefix = trimmed.substring(0, 40).trim();
    const suffix = trimmed.substring(trimmed.length - 40).trim();
    return encodeURIComponent(prefix + HIGHLIGHT_SEPARATOR + suffix);
}

export function buildContextParam(before: string, after: string): string {
    return encodeURIComponent(before + HIGHLIGHT_SEPARATOR + after);
}

export function buildNormalizedToRawMap(accumulated: string): number[] {
    const normalizedToRaw: number[] = [];
    let inWhitespace = false;
    for (let i = 0; i < accumulated.length; i++) {
        if (/\s/.test(accumulated[i])) {
            if (!inWhitespace) {
                normalizedToRaw.push(i);
                inWhitespace = true;
            }
        } else {
            normalizedToRaw.push(i);
            inWhitespace = false;
        }
    }
    return normalizedToRaw;
}

export function findAllOccurrences(normalizedText: string, searchNormalized: string): number[] {
    if (!searchNormalized) return [];
    const indices: number[] = [];
    let startIdx = 0;
    while (true) {
        const idx = normalizedText.indexOf(searchNormalized, startIdx);
        if (idx === -1) break;
        indices.push(idx);
        startIdx = idx + 1;
    }
    return indices;
}

export function selectOccurrenceByContext(
    normalizedText: string,
    occurrences: number[],
    searchLength: number,
    context: { before: string; after: string }
): number {
    if (occurrences.length === 1) return occurrences[0];

    const normalizedBefore = context.before.replace(/\s+/g, " ").trim();
    const normalizedAfter = context.after.replace(/\s+/g, " ").trim();

    let bestIdx = occurrences[0];
    let bestScore = -1;

    for (const idx of occurrences) {
        let score = 0;
        if (normalizedBefore) {
            const textBefore = normalizedText.substring(Math.max(0, idx - normalizedBefore.length - 5), idx);
            if (textBefore.includes(normalizedBefore)) {
                score += normalizedBefore.length;
            }
        }
        if (normalizedAfter) {
            const textAfter = normalizedText.substring(idx + searchLength, idx + searchLength + normalizedAfter.length + 5);
            if (textAfter.includes(normalizedAfter)) {
                score += normalizedAfter.length;
            }
        }
        if (score > bestScore) {
            bestScore = score;
            bestIdx = idx;
        }
    }

    return bestIdx;
}
